import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

interface ButtonFormActionsProps {
  onClose: () => void;
}

export const ButtonFormActions = ({ onClose }: ButtonFormActionsProps) => (
  <div className="flex justify-end gap-x-3 pb-5 pt-2.5">
    <Button type="button" onClick={onClose} variant="secondary-light">
      {t("cancel")}
    </Button>
    <Button type="submit" variant="circle">
      {t("email_editor.cta.save")}
    </Button>
  </div>
);
